import { UseFormReturn } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

interface PersonFormValues {
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  cnp?: string;
  gender?: string;
  birthDate?: string;
  country?: string;
  city?: string;
  address?: string;
}

interface PersonCreateFormProps {
  form: UseFormReturn<PersonFormValues>;
}

export default function PersonCreateForm({ form }: PersonCreateFormProps) {
  return (
    <div className="grid gap-4">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="firstName">Prenume *</Label>
          <Input
            id="firstName"
            {...form.register('firstName')}
            className={form.formState.errors.firstName ? 'border-destructive' : ''}
          />
          {form.formState.errors.firstName && (
            <p className="text-sm text-destructive">{form.formState.errors.firstName.message}</p>
          )}
        </div>
        <div className="space-y-2">
          <Label htmlFor="lastName">Nume *</Label>
          <Input
            id="lastName"
            {...form.register('lastName')}
            className={form.formState.errors.lastName ? 'border-destructive' : ''}
          />
          {form.formState.errors.lastName && (
            <p className="text-sm text-destructive">{form.formState.errors.lastName.message}</p>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" {...form.register('email')} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="phone">Telefon</Label>
          <Input id="phone" {...form.register('phone')} />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="cnp">CNP</Label>
          <Input id="cnp" {...form.register('cnp')} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="birthDate">Data Nașterii</Label>
          <Input id="birthDate" type="date" {...form.register('birthDate')} />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="gender">Gen</Label>
          <Select
            value={form.watch('gender') || ''}
            onValueChange={(value) => form.setValue('gender', value)}
          >
            <SelectTrigger>
              <SelectValue placeholder="Selectați" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="Masculin">Masculin</SelectItem>
              <SelectItem value="Feminin">Feminin</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="country">Țară</Label>
          <Input id="country" {...form.register('country')} />
        </div>
        <div className="space-y-2">
          <Label htmlFor="city">Oraș</Label>
          <Input id="city" {...form.register('city')} />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="address">Adresă</Label>
        <Input id="address" {...form.register('address')} />
      </div>
    </div>
  );
}
